var map = {
	"./aheadworks.jpg": "aba0",
	"./buissonniere.jpg": "822f",
	"./citrix_logo.jpg": "3d06",
	"./citrixsynergy.jpg": "727c",
	"./csc.jpg": "1918",
	"./csc_logo.jpg": "b847",
	"./kukimi.jpg": "518b",
	"./kukimide.jpg": "6e66",
	"./magento.jpg": "f7de",
	"./magento_icons/adobe.jpg": "68e7",
	"./magento_icons/magento.jpg": "a563",
	"./magento_icons/ms_azure.jpg": "ef6b",
	"./magento_icons/zabix.jpg": "dddf",
	"./oscommers.jpg": "4d54",
	"./qg-main.jpg": "2c80",
	"./qg.jpg": "5416",
	"./qg2.jpg": "c781",
	"./transact.jpg": "a463",
	"./york.jpg": "e69e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "56b1";